import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../../App.css';
import { useState } from "react";
import FeedbackCart from "../../Components/Home/FeedbackCart";
import Footer from '../../Components/ReusableComponents/Footer';
import GetInTouch from '../../Components/ReusableComponents/GetInTouch'
import Header from '../../Components/ReusableComponents/Header';
import { Link, useHistory } from 'react-router-dom';
import QualityHomeCart from "../../Components/Home/QualityHomeCart"
import { useEffect } from 'react'
import Slider from "react-slick";
import { useLocate } from "../../CustomHooks/useLocate";
import API from "../../utils/apiCalling";
import Loader from "../../utils/loader";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Config from '../../config/env'
function Home() {
     let history=new useHistory()
     const [value] = useLocate()
     const [showQuestion, setShowQuestion] = useState("0")
     const [quesno, setQuesNumber] = useState(0);
     const [questions, setQuestions] = useState([]);
     const [answer, setTemporaryAns] = useState([])
     const [button, setButton] = useState(false)
     const [loader, setLoader] = useState(false)
     const [result, setResult] = useState()
     var settings = {
          dots: false,
          infinite: true,
          speed: 1000,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 5000,
     };
     const api = new API()
     useEffect(() => {
          window.scroll(0, 0);
          localStorage.setItem("userType", `panelist`)
          let user = JSON.parse(localStorage.getItem('user'))
if(user && user.userType=='client'){
     user.plan_id ? history.push('/adminDash'):history.push('/plan')
}
else if(user && (user.userType=='panelist' || user.userType=='admin') ){
     history.push('/panelistDash')
}
     }, [])
     const next = (question) => {
          question.answer = answer;
          setTemporaryAns([]);
          if (quesno === questions.length - 1) {
               submitTryMeOut()
               setQuesNumber("end")
          } else {
               setQuesNumber(quesno + 1)
          }
          setButton(false)
     }
     const tryMeOut = async () => {
          setLoader(true)
          var result = await api.get(`${Config.new.site_api}/admin-dashboard/tryMeOut`)
          if (result.code === 200) {
               setResult(result.data);
               setQuestions(result.data.questions);
               setLoader(false)
          }
     }
     const setAnswer = (event, type) => {
          let ans = []
          if (type == 'checkbox') {
               if (answer.includes(event.target.value)) {
                    let index = answer.indexOf(event.target.value)
                    answer.splice(index, 1);
               }
               else {
                    answer.push(event.target.value)
                    setTemporaryAns(answer)
               }
          }
          else {
               ans.push(event.target.value)
               setTemporaryAns(ans)
          }
          setButton(true)
          event.target.checked = false
          next(questions[quesno])
     }
     const submitTryMeOut = async () => {
          let data = {
               surveyName: result.survey_name,
               surveyId: result._id,
               surveyType: result.survey_type,
               questions: JSON.stringify(questions)
          }
          // const result1 = 
          await api.post(`${Config.new.site_api}/admin-dashboard/submitTryMeOut`, data)
          // if(result1.code==200){
          //      alert("done")
          // }if(result1.code!==200){
          //      alert("Not done")
          // }
     }
     /* This is for the Feedback slider */
     // let settings = {
     //      dots: true,
     //      slidesToShow: 3,
     //      responsive: [{
     //           breakpoint: 900,
     //           settings: {
     //                slidesToShow: 1,
     //           }
     //      }]
     // };
     /* This is for Testimonial Slider  */
     let test = {
          // slidesToShow: 4,
          // loop: true,
          // margin: 10,
          // dots: false,
          // nav: true,
          // autoplay: true,
          // slideTransition: 'linear',
          // autoplayTimeout: 3000,
          // smartSpeed: 3000,
          // animateOut: "slideOutUp",
          // autoplayHoverPause: 'true',
          // responsive: [
          //      {
          //           breakpoint: 800,
          //           test: {
          //                slidesToShow: 3,
          //                nav: false,
          //           },
          //      },
          //      {
          //           breakpoint: 600,
          //           test: {
          //                slidesToShow: 2,
          //                nav: false,
          //           },
          //      }
          // ],
          dots: false,
          infinite: true,
          nav: true,
          autoplay: true,
          loop: true,
          speed: 900,
          autoplaySpeed: 700,
          speed: 3000,
          margin: 10,
          slideTransition: 'linear',
          autoplayTimeout: 3000,
          smartSpeed: 3000,
          animateOut: "slideOutUp",
          autoplayHoverPause: 'true',
          slidesToShow: 4,
          slidesToScroll: 4,
          responsive: [
               {
                    breakpoint: 1024,
                    settings: {
                         dots: false,
                         infinite: true,
                         nav: true,
                         autoplay: true,
                         loop: true,
                         speed: 3000,
                         margin: 10,
                         centerPadding: '40px',
                         slideTransition: 'linear',
                         autoplayTimeout: 3000,
                         smartSpeed: 3000,
                         animateOut: "slideOutUp",
                         autoplayHoverPause: 'true',
                         slidesToShow: 3,
                         slidesToScroll: 3,
                    }
               },
               {
                    breakpoint: 600,
                    settings: {
                         dots: false,
                         infinite: true,
                         nav: true,
                         autoplay: true,
                         loop: true,
                         speed: 3000,
                         margin: 10,
                         centerPadding: '40px',
                         slideTransition: 'linear',
                         autoplayTimeout: 3000,
                         smartSpeed: 3000,
                         padding: 30,
                         animateOut: "slideOutUp",
                         autoplayHoverPause: 'true',
                         slidesToShow: 2,
                         slidesToScroll: 2,
                    }
               },
               {
                    breakpoint: 480,
                    settings: {
                         dots: false,
                         infinite: true,
                         nav: true,
                         autoplay: true,
                         loop: true,
                         speed: 3000,
                         margin: 10,
                         padding: 30,
                         centerMode: true,
                         centerPadding: '40px',
                         slideTransition: 'linear',
                         autoplayTimeout: 3000,
                         smartSpeed: 3000,
                         animateOut: "slideOutUp",
                         autoplayHoverPause: 'true',
                         slidesToShow: 1,
                         slidesToScroll: 1,
                    }
               }
               // You can unslick at a given breakpoint now by adding:
               // settings: "unslick"
               // instead of a settings object
          ]
     };
     return (
          <>
               {/* <Header loginStatus={true} /> */}
               <section>
                    <div className="topBar nevigtsao w-100 p-2 bg-blue" style={{ minHeight: "40px" }}>
                         <div className="container-fluid">
                              <div className="row" style={{ position: "relative" }}>
                                   <div className="col-md-12 mx-auto d-flex justify-content-between">
                                        <div className='topTextSlide'>
                                             <span className='text-heading-header text-white text-center' style={{ fontWeight: "500" }}>Streamlining the Market Research Process..</span>
                                             {/* <Slider {...{
                                                dots: false,
                                                autoplay: true,
                                                infinite: true,
                                                speed: 500,
                                                autoplaySpeed: 3000,
                                                arrows: false,
                                                slidesToShow: 1,
                                                slidesToScroll: 1,
                                                vertical: true,
                                                verticalSwiping: true,
                                                swipeToSlide: true
                                            }}
                                                className="topTextSlide">
                                                <div className="">
                                                    <p className="text-white text-center mb-0">All that Construction needs</p>
                                                </div>
                                                <div className="">
                                                    <p className="text-white text-center mb-0">All that Construction needs2</p>
                                                </div>
                                                <div className="">
                                                    <p className="text-white text-center mb-0">All that Construction needs3</p>
                                                </div>
                                            </Slider> */}
                                        </div>
                                        <ul className="head-email d-flex mb-0 justify-content-end detailTopView">
                                             <li><a href="https://mail.google.com/mail/u/0/?fs=1&to=dysinfo@qdegrees.com&tf=cm" target="break">
                                                  <i className="fa fa-envelope text-white" aria-hidden="true"></i>&nbsp;&nbsp;<span className='text-white' style={{ fontWeight: "500" }}>dysinfo@qdegrees.com</span>
                                             </a></li>
                                             <li> <Link href="/get-app">
                                                  <a href="#" className='' style={{ fontWeight: "500" }}>
                                                       Get App
                                                  </a>
                                             </Link></li>
                                             <li><a href="https://play.google.com/store/apps/details?id=com.qdegrees.doyoursurvey" target="_blank">
                                                  {/* <img src='../images/playstore.png' width={"20px"} aria-hidden="true"></img> */}
                                                  <i class="bi bi-google-play"></i>
                                             </a></li>
                                             <li> <Link href="" target="_blank">
                                                  <a href="https://apps.apple.com/us/app/doyoursurvey/id1662091417" target="_blank" >
                                                  <i class="bi bi-apple" aria-hidden="true"></i>
                                                  </a>
                                             </Link></li>
                                        </ul>
                                   </div>
                              </div>
                         </div>
                    </div>
                    {/* <div className="topBar w-100 ">
                         <div className="container">
                              <div className="row" style={{ position: 'relative', padding:"6px" }}>
                                   <div className="col-md-4 col-lg-6 mx-auto ">
                                   <p className="text-white text-center mb-0 fs-6">All that Construction needs3</p>
                                   </div>
                                   <div className='col-lg-4 mx-auto'>
                                   <ul className="d-flex mb-0 justify-content-end detailTopView">
                                        <li><a href="#"><i className="fa fa-phone" aria-hidden="true" /> +91 7878159468</a></li>
                                        <li><a href="#"><i className="fa fa-envelope" aria-hidden="true" /></a></li>
                                        <li> <a href="#">Get App</a></li>
                                    </ul>
                                   </div>
                              </div>
                         </div>
                    </div> */}
                    {/* <div data-index={0} className="slick-slide" tabIndex={-1} aria-hidden="true" style={{ outline: 'none', width: '546px' }}><div>
                                             <div className tabIndex={-1} style={{ width: '100%', display: 'inline-block' }}><p className="text-black text-center mb-0">All that Construction needs</p></div></div></div><div data-index={1} className="slick-slide" tabIndex={-1} aria-hidden="true" style={{ outline: 'none', width: '546px' }}><div><div className tabIndex={-1} style={{ width: '100%', display: 'inline-block' }}><p className="text-black text-center mb-0">All that Construction needs2</p></div></div></div><div data-index={2} className="slick-slide slick-active slick-current" tabIndex={-1} aria-hidden="false" style={{ outline: 'none', width: '546px' }}><div><div className tabIndex={-1} style={{ width: '100%', display: 'inline-block' }}><p className="text-black text-center mb-0">All that Construction needs3</p></div></div></div><div data-index={3} tabIndex={-1} className="slick-slide slick-cloned" aria-hidden="true" style={{ width: '546px' }}><div><div className tabIndex={-1} style={{ width: '100%', display: 'inline-block' }}><p className="text-black text-center mb-0">All that Construction needs</p></div></div></div><div data-index={4} tabIndex={-1} className="slick-slide slick-cloned" aria-hidden="true" style={{ width: '546px' }}><div><div className tabIndex={-1} style={{ width: '100%', display: 'inline-block' }}><p className="text-black text-center mb-0">All that Construction needs2</p></div></div></div><div data-index={5} tabIndex={-1} className="slick-slide slick-cloned" aria-hidden="true" style={{ width: '546px' }}><div><div className tabIndex={-1} style={{ width: '100%', display: 'inline-block' }}><p className="text-black text-center mb-0">All that Construction needs3</p></div></div></div></div><ul className="d-flex mb-0 justify-content-end detailTopView"><li><a href="#"><i className="fa fa-phone" aria-hidden="true" /> +91 7878159468</a></li><li><a href="#"><i className="fa fa-envelope" aria-hidden="true" /></a></li><li> <a href="#">Get App</a></li></ul> */}
               </section>
               <section id="all-section nav-section" className='myheaderLogo position-relative' style={{background:"none"}}>
                    <nav className="navbar menuglta navbar-expand-lg py-2 w-100 fadeInDown">
                         <div className="container-fluid">
                              <a className="navbar-brand brandNavbi" href="/">
                                   <img src="../images/new-logo.png" alt="" ></img>
                              </a>
                              {/* <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                   <span className="navbar-toggler-icon" />
                              </button> */}
                              <div className="" id="navbarSupportedContent">
                                   <form className="ms-auto" role="search">
                                        <Link to="/demo">
                                             {/* <button className="mainbtn mx-3 fadeInUp" href="#" target="_self">
                                                  Book a Demo
                                             </button> */}
                                        </Link>
                                             <Link to="/login"> <button className="mainbtn fadeInUp" href="#" target="_self">
                                                  Sign In
                                             </button>
                                             </Link> 
                                   </form>
                              </div>
                         </div>
                    </nav>
               </section>
               {loader && <Loader />}
               <section id="all-sections" className="bg-grey fullheight bannersec measheader" >
                    <div className="container text-center h-100">
                         <div className="row justify-content-center align-items-center h-100">
                              <div className="col-md-10 col-lg-9 text-center">
                                   <Slider {...settings}>
                                        <div className=''>
                                             <h1 className=" text-white bannerheading" style={{ fontWeight: "900" }}>
                                                  Digital to Conversational Surveys.
                                             </h1>
                                             <p className="text-grey bannersec-p">
                                                  Transform your traditional web forms into a delightful conversation
                                             </p>
                                        </div>
                                        <div className=''>
                                             <h1 className="text-white bannerheading" style={{ fontWeight: "900" }}>
                                                  Conduct Digital Survey for Rural to Global Reach
                                             </h1>
                                             <p className="text-grey bannersec-p">
                                                  Get a deep dive insight from a rural to a global audience.
                                             </p>
                                        </div>
                                        <div className=''>
                                             <h1 className="text-white bannerheading" style={{ fontWeight: "900" }}>
                                                  Connect to the audience in Vernacular Languages
                                             </h1>
                                             <p className="text-grey bannersec-p">
                                                  Reach out to your audience to seek insights by communicating with them in their language.
                                             </p>
                                        </div>
                                        <div className=''>
                                             <h1 className="text-white bannerheading" style={{ fontWeight: "900" }}>
                                                  Seek inputs through Voice based Survey
                                             </h1>
                                             <p className="text-grey bannersec-p">
                                                  Reach out to your audience to seek insights by communicating with them in their language.
                                             </p>
                                        </div>
                                        <div className=''>
                                             <h1 className="text-white bannerheading" style={{ fontWeight: "900" }}>
                                                  Conduct Personal Interviews across India
                                             </h1>
                                             <p className="text-grey bannersec-p">
                                                  Communicate with B2B and B2C audiences in Pan India
                                             </p>
                                        </div>
                                        <div className=''>
                                             <h1 className="text-white bannerheading" style={{ fontWeight: "900" }}>
                                                  Telephonic Interviews across India & Abroad
                                             </h1>
                                             <p className="text-grey bannersec-p">
                                                  Seek in-depth insights by connecting with the audience in their language through telephonic discussions
                                             </p>
                                        </div>
                                        <div className=''>
                                             <h1 className="text-white bannerheading" style={{ fontWeight: "900" }}>
                                                  44 Million+ Global Panel
                                             </h1>
                                             <p className="text-grey bannersec-p">
                                                  To meet the needs of our clients, we constantly build, fortify, and maintain our panels.
                                                  We are pleased with our double opt-in, quality-assured proprietary panels all over the world.
                                             </p>
                                        </div>
                                        <div className=''>
                                             <h1 className="text-white bannerheading" style={{ fontWeight: "900" }}>
                                                  AI-powered market research with a people-centric approach.
                                             </h1>
                                             <p className="text-grey bannersec-p">
                                                  Bold decision-making is driven by actionable intelligence.
                                             </p>
                                        </div>
                                        <div className=''>
                                             <h1 className="text-white bannerheading" style={{ fontWeight: "900" }}>
                                                  Access to global feedback with different modes of research.
                                             </h1>
                                             <p className="text-grey bannersec-p">
                                                  Tap into the power of globalization by collecting responses from all over the world.
                                             </p>
                                        </div>
                                        <div className=''>
                                             <h1 className="text-white bannerheading" style={{ fontWeight: "900" }}>
                                                  Market research reimagined.
                                             </h1>
                                             <p className="text-grey bannersec-p">
                                                  Simple, DIY solution with a visual dashboard for proactive research.
                                             </p>
                                        </div>
                                   </Slider>
                                   {/* <Slider {...{
                                                dots: false,
                                                autoplay: true,
                                                infinite: true,
                                                speed: 400,
                                                autoplaySpeed: 3000,
                                                arrows: false,
                                                slidesToShow: 1,
                                                slidesToScroll: 1,
                                                vertical: true,
                                                verticalSwiping: true,
                                                swipeToSlide: true
                                            }}
                                            className="topTextSlide" style={{height:"150px"}}>
                                   <h1 className=" text-white bannerheading" style={{ fontWeight: "900" }}>
                                        AI-powered market research with a people-centric approach.
                                   </h1>
                                   <p className="text-grey bannersec-p">
                                        Bold decision-making is driven by actionable intelligence.
                                        Tap into the power of globalization by collecting responses from all over the world.
                                   </p>
                                   <h1 className="text-white bannerheading" style={{ fontWeight: "900" }}>
                                        Access to global feedback with different modes of research.
                                   </h1>
                                   <p className="text-grey bannersec-p">
                                   Tap into the power of globalization by collecting responses from all over the world
                                   </p>
                                   <h1 className="text-white bannerheading" style={{ fontWeight: "900" }}>
                                   Market research reimagined. 
                                   </h1>
                                   <p className="text-grey bannersec-p">
                                   Simple, DIY solution with a visual dashboard for proactive research. 
                                   </p>
                              </Slider> */}
                              </div>
                         </div>
                    </div>
               </section>
               <section id="all-sections" className="floating-sec"  >
                    <div className="container">
                         <div className="row text-center justify-content-center align-items-center">
                              <div className="col-md-10">
                                   <div className=" bg-blue overflowsec HeyImas" style={{ display: "flex", justifyContent: "center", padding:"30px 10px" }}>
                                        <div className="heyImdo d-flex gap-5 align-items-center m-auto">
                                             <div className="">
                                                  <h1 className="text-orange m-0 d-flex lottie_containered align-items-center justify-content-center fs-3"><span>Hey&nbsp;</span> 
                                                  <lottie-player src="https://assets9.lottiefiles.com/packages/lf20_hqfbl3nn.json" background="transparent" style={{ width: '90px', height: '90px' }} loop autoPlay />
                                                  <span>I'm</span>
                                                  </h1>
                                             </div>
                                             <div className="logIng">
                                                  <img src="../images/new-logo.png" width="150px" alt="" />
                                             </div>
                                             <div className="">
                                                  <button type="button" className=" mainbtn fadeInUp" onClick={(e) => tryMeOut()} data-bs-toggle="modal" data-bs-target="#exampleModalScrollable">Try me out</button>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>
               </section>
               <section id="all-section">
                    <div className="container">
                         <div className="insights p-4">
                              <div className="row justify-content-center">
                                   <div className="col-lg h-100">
                                        <div className="card border-0 insights-card text-center">
                                             <div className="card-heading">
                                                  <p className="text-blue fs-2 mb-2">
                                                       Be Our&nbsp;<strong className="text-orange">Client</strong>
                                                  </p>
                                                  <h4 className="text-black">Get Insights</h4>
                                             </div>
                                             <img src="../images/Group 1003.svg" className="w-100" alt="" />
                                             <p className="boldcommon-p">
                                                  Get access to global audience with exclusive &amp; treasured
                                                  insights.
                                             </p>
                                             <Link to='/client'>
                                                  <button className="mainbtn fadeInUp" onClick={(e) => localStorage.setItem("userType", `client`)} href="#" target="_self">
                                                       Sign Up
                                                  </button>
                                             </Link>
                                        </div>
                                   </div>
                                   <div className="col-lg-1 p-0">
                                        <div className="divide d-flex justify-content-center h-100">
                                             <div className="vr" />
                                             <hr className="d-none " />
                                        </div>
                                   </div>
                                   <div className="col-lg">
                                        <div className="card border-0 insights-card text-center">
                                             <div className="card-heading">
                                                  <p className="text-blue fs-2 mb-2">
                                                       Be Our&nbsp;<strong className="text-orange">Panelist</strong>
                                                  </p>
                                                  <h4 className="text-black">Reward Your Opinion</h4>
                                             </div>
                                             <img src="../images/Group 1975.svg" className="w-100" alt="" />
                                             <p className="boldcommon-p">
                                                  Share your views and make a difference, whilst being
                                                  rewarded for your time.
                                             </p>
                                             <Link to='/panelist'> <button className="mainbtn fadeInUp" onClick={(e) => localStorage.setItem("userType", `panelist`)} href="#" target="_self">
                                                  Sign Up
                                             </button>
                                             </Link>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>
               </section>
               <section id="all-section">
                    <div className="client-cards">
                         <div className="container">
                              <div className="row text-center justify-content-center">
                                   <h2 className="fw-bold my-5 fs-2">Be Our <strong className="fs-1 text-orange">Client</strong></h2>
                                   <QualityHomeCart
                                        img="../images/Group 6289.svg"
                                        Heading="Collect responses in real-time"
                                        description=" Our superior incentives ensure that your chosen
                                             respondents answer quickly. You can start analyzing
                                             the data in real-time as soon as the responses start
                                             pouring in."
                                   />
                                   <QualityHomeCart
                                        img="../images/Group 6290.svg"
                                        Heading="Multi-level quality check for quality research
                                        outcomes"
                                        description="    We ensure transparency in all the responses that come
                                        in from our panelists. This is done via a three-level
                                        system of quality checks. First, each panelist is
                                        qualified before the survey begins."
                                   />
                                   <QualityHomeCart
                                        img="../images/Group 6291a.svg"
                                        Heading="Choose panelists from around the world"
                                        description="      Based on your chosen mode of research you can pick
                                        from a diversified global audience to expand the scope
                                        of your research around the world."
                                   />
                                   <QualityHomeCart
                                        img="../images/Group 6294.svg"
                                        Heading="Geo-target your chosen panelists"
                                        description="    We understand the importance of location-based
                                        research. We built a solution that can target
                                        respondents accurately based on their geo-locations
                                        and IP addresses."
                                   />
                                   <QualityHomeCart
                                        img="../images/Group 6293.svg"
                                        Heading="  Pick from different modes of research"
                                        description="     In-depth research requires a cross-modal approach. We
                                        offer various types of research under one tool along
                                        with professional consulting services for an
                                        exhaustive analysis of the study."
                                   />
                                   <QualityHomeCart
                                        img="../images/Group 6292.svg"
                                        Heading=" Visualize data with our DIY platform and intuitive
                                        dashboard"
                                        description=" Our AI-powered solution empowers you to handle your
                                        research proactively on your own. The intuitive
                                        dashboard gives you unmatched visibility across all
                                        key metrics and helps you make sense of all the
                                        information easily."
                                   />
                                   <h3 className="animated headid9 infinite pulse delay-3 fw-bold text-blue my-5">
                                        Start your own survey now!<span>
                                             <Link to="/client">   <button className="mainbtn" onClick={(e) => localStorage.setItem("userType", `client`)} >StartNow</button> </Link> </span>
                                   </h3>
                              </div>
                         </div>
                    </div>
               </section>
               <section id="all-section" className="bg-pink">
                    <div className="container-fluid">
                         <div className="row text-center justify-content-center py-5">
                              <div className="col-md-8">
                                   <p className="fw-normal m-0 lh-base fs-5">
                                        At QDegrees, we understand the value of honest, real-time
                                        opinions - while voicing them out and while listening to them.
                                        That’s why we built an intuitive DIY platform that lets you
                                        choose your preferred mode of research and your preferred target
                                        respondents
                                   </p>
                              </div>
                         </div>
                    </div>
               </section>
               <section id="all-section">
                    <div className="client-cards">
                         <div className="container">
                              <div className="row text-center justify-content-center">
                                   <div className="col-md-11">
                                        <div className="row">
                                             <h2 className="fw-bold fs-2 my-5">
                                                  Be Our <strong className="fs-1 text-orange" onClick={(e) => localStorage.setItem("userType", `panelist`)}>Panelist</strong>
                                             </h2>
                                             <QualityHomeCart
                                                  img="../images/Group 6295.svg"
                                                  Heading="  Get involved with product RnD"
                                                  description=" Companies require your insights to help them build
                                                  products that you like. By answering our surveys in
                                                  your leisure time, you not only influence the products
                                                  that these companies launch but also build a long-term
                                                  relationship with them."
                                             />
                                             <QualityHomeCart
                                                  img="../images/Group 6296.svg"
                                                  Heading=" Long-term benefits"
                                                  description=" Signing up to be our panelist is just the first step
                                                  in a long and fruitful relationship. You get to share
                                                  your ideas &amp; feedback with your favorite industries
                                                  and companies ."
                                             />
                                             <QualityHomeCart
                                                  img="../images/Group 6297.svg"
                                                  Heading="      Direct cash in your wallet"
                                                  description=" Your opinion has the power to influence brands. Share
                                                  your insights by completing surveys and be rewarded
                                                  instantly! Our surveys take less than 10 minutes to
                                                  finish. And you get paid in cash in your Paytm or GPay
                                                  wallet for your opinions."
                                             />
                                             <h3 className="animated headid9 infinite pulse delay-3 fw-bold text-blue my-5">
                                                  Ready to earn now?<span>
                                                       <Link to="/panelist"> <button className="mainbtn">Start
                                                            Now</button></Link>
                                                  </span>
                                             </h3>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>
               </section>
               <section id="all-section" className=" bg-pink py-5">
                    <div className="container testimonial gtco-testimonials">
                         <div className="row justify-content-center">
                              <div className="col-md-12 bg-white">
                                   {/* <h2 className="fw-bold fs-2 text-center ">
                                        Client's <strong className="fs-1 text-orange">Feedback</strong>
                                   </h2> */}
                                   {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                                        labore et dolore magna aliqua.</p> */}
                              </div>
                              <div className="col-md-7 " style={{ display: "flex", alignItems: "center" }}>
                                   <div className="w-100 p-1 powerOnion">
                                        <h4 className="fw-bold text-blue py-2" style={{ fontSize: "42px" }}>The power of opinion, in the palm of your hand</h4>
                                        <p className=" text-left" style={{ color: "#f47321" }}>Start Today. Be our Panelist</p>
                                        {/* <div className="mb-3 py-2">
                                             <label htmlFor="exampleInputEmail1" className="form-label" style={{color:"#f47321"}}>GET DOWNLOAD LINK VIA SMS</label>
                                                       <input type="email" className="form-control" id="exampleInputEmail1" placeholder="Enter Your Moblie Number" aria-describedby="emailHelp" />
                                                       <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div>
                                        </div> */}
                                        <p className="fw-bold text-blue text-left" style={{ color: "#f47321" }}>Available On</p>
                                        <div className="w-100" style={{ display: "flex", justifycontent: "space-around" }}>
                                             <div className="google-play-btn">
                                                  <button type="button" className="btn-play-google mt-1 mr-2" onClick={() => window.open("https://play.google.com/store/apps/details?id=com.qdegrees.doyoursurvey", '_blank')}><img src="../images/playstore.png" width={"45"}></img>Google Play</button>
                                                  <button type="button" className="btn-play-ios mb-1 mr-2" onClick={() => window.open("https://apps.apple.com/in/app/doyoursurvey/id1662091417", '_blank')}><img src="../images/apple.png" width={"45"}></img> App Store</button>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                              <div className="col-md-5">
                                   <div className="w-100 d-flex justify-Content-Center" style={{ justifyContent: "center" }}>
                                        <img src="../images/png1.png" width={"250px"}></img>
                                   </div>
                              </div>
                         </div>
                    </div>
               </section>
               <section className=" testimonail-slide w-100 py-5">
                    <div className="container">
                         <div className="row justify-content-center">
                              <h2 className="fw-bold fs-2 text-center mb-4">
                                   Trusted <strong className="fs-1 text-orange">By</strong>
                              </h2>
                              <div className="col-md-12 mt-0">
                                   <div className="slickBestSponsor wow fadeInDown">
                                        <Slider {...test}>
                                             <div className="item">
                                                  <img src="../images/client-logo2/afg.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/ajman.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/amazon.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/amazonpay-logo.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/apollo-logo.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/axis-bank.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/canara.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/cure-fit-logo.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/daimler-logo.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/dcb-bank.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/dmi-logo.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/dr.batra-logo.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/dunzo.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/eat-fit-logo.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/eicher-logo.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/flf.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/girnar-logo.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/hometown.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/hotstar.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/icici-securities.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/idfc-bank.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/mahindra.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/manappu.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/oppoLogo.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/piramal.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/royaloak.png" alt="" />
                                             </div>
                                             {/* <div className="item">
                                                  <img src="../images/client-logo2/samsung-logo.png" height={"110px"} alt="" />
                                             </div> */}
                                             <div className="item">
                                                  <img src="../images/client-logo2/scriptif.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/soch.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/swiggy-logo.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/tata aia.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/tata motor.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/tata.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/uber.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/vi-logo.png" alt="" />
                                             </div>
                                             <div className="item">
                                                  <img src="../images/client-logo2/volvo.png" alt="" />
                                             </div>
                                        </Slider>
                                   </div>
                              </div>
                         </div>
                    </div>
               </section>
               <GetInTouch redirectionStatus={false} />
               <div className="modal trylModal" id="exampleModalScrollable" aria-labelledby="exampleModalScrollableTitle">
                    <div className="modal-dialog modal-dialog-scrollable">
                         <div className="modal-content">
                              <div class="modal-header border align-items-center" style={{ backgroundColor: "rgb(245 245 245)" }}>
                                   <a className="navbar-brand1" href="#"><img src="../images/new-logo.png" width="80px" alt="" /></a>
                                   <button type="button" class="btn-close" data-bs-dismiss="modal" onClick={(e) => { setQuesNumber(0) }}></button>
                              </div>
                              <div className="modal-body p-0">
                                   {showQuestion === 0 &&
                                        <div className="row m-0 ">
                                             <div className="col-md-6 p-0">
                                                  <div className="text-white w-100 contentTrly px-4 py-5 h-100">
                                                       <h4>Simply dummy text of the printing and typesetting industry.</h4>
                                                       <p>simply dummy text of the printing and typesetting industry.</p>
                                                       <p className="mb-5">Lorem Ipsum has been the industry's standard dummy text ever since the
                                                            1500s, when an unknown printer took a galley of type and scrambled it to make a type
                                                            specimen book. It has survived not only five centuries,</p>
                                                       <button onClick={() => () => setShowQuestion(1)} className="mainBtn tabe bg-white mt-4">There's more</button>
                                                  </div>
                                             </div>
                                             <div className="col-md-6 p-0">
                                                  <img src="../images/try-popup.png" className="h-100" alt="" />
                                             </div>
                                        </div>
                                   }
                                   {
                                        showQuestion !== 0 &&
                                        <div className="row m-0 ">
                                             <div className="col-md-12 p-0">
                                                  <div className="qusSec my-sawqa" style={{ minHeight: "100%" }}>
                                                       {/* <form > */}
                                                       {questions && questions[quesno] && (<div className="w-100 ">
                                                            <h5 className="mb-4">Q{quesno + 1}. {questions[quesno].question}</h5>
                                                            <div className="mainOttsb">
                                                            {questions && questions[quesno] && questions[quesno].options.map((op, index) => (
                                                                 <label className="lblRadio">
                                                                      <input className="w-100" type="radio" name="radio" value={op.option} onChange={(e) => { setAnswer(e, questions[quesno].type) }} />
                                                                      <div className="checkmarkRdio">
                                                                          {op.option}
                                                                      </div>
                                                                 </label>
                                                            ))}
                                                            </div>
                                                            {/* {button && <div className="w-100 text-right">
                                                                 <button onClick={()=>next(questions[quesno])} className="mainBtn tabe bg-white mt-4 btnQas">Next</button>
                                                            </div>} */}
                                                       </div>)}
                                                       {/* <div className="w-100 ">
                                                                 <h5 className="mb-4">Q. 2 How much time you’ve spent with this organization ?</h5>
                                                                 <label className="lblRadio">
                                                                      <input type="radio" name="radio" />
                                                                      <div className="checkmarkRdio">
                                                                           <span>A</span>
                                                                           Less than 6 months
                                                                      </div>
                                                                 </label>
                                                                 <label className="lblRadio">
                                                                      <input type="radio" name="radio" />
                                                                      <div className="checkmarkRdio">
                                                                           <span>B</span>
                                                                           6-12 months
                                                                      </div>
                                                                 </label>
                                                                 <label className="lblRadio">
                                                                      <input type="radio" name="radio" />
                                                                      <div className="checkmarkRdio">
                                                                           <span>C</span>
                                                                           1.1-2 years
                                                                      </div>
                                                                 </label>
                                                                 <label className="lblRadio">
                                                                      <input type="radio" defaultChecked="checked" name="radio" />
                                                                      <div className="checkmarkRdio">
                                                                           <span>D</span>
                                                                           2.1-3 years
                                                                      </div>
                                                                 </label>
                                                                 <label className="lblRadio">
                                                                      <input type="radio" name="radio" />
                                                                      <div className="checkmarkRdio">
                                                                           <span>E</span>
                                                                           More than 3 years
                                                                      </div>
                                                                 </label>
                                                                 <div className="w-100 text-right">
                                                                      <button type="submit" onClick={() => setShowQuestion(3)} className="mainBtn tabe bg-white mt-4 btnQas">Next</button>
                                                                 </div>
                                                            </div> */}
                                                       {/* <div className="w-100 ">
                                                                 <h5 className="mb-4">Q. 3 Lorem Ipsum is simply dummy text of the printing and
                                                                      typesetting industry.</h5>
                                                                 <div className="w-100 imgOption">
                                                                      <label className="lblRadio">
                                                                           <input type="radio" name="radio" />
                                                                           <div className="checkmarkRdio">
                                                                                <img src="src/login-bg.jpg" className="w-100 mb-2" alt="" />
                                                                                <span>A</span>
                                                                                Dummy Text
                                                                           </div>
                                                                      </label>
                                                                      <label className="lblRadio">
                                                                           <input type="radio" name="radio" />
                                                                           <div className="checkmarkRdio">
                                                                                <img src="src/login-bg.jpg" className="w-100 mb-2" alt="" />
                                                                                <span>B</span>
                                                                                Dummy Text
                                                                           </div>
                                                                      </label>
                                                                      <label className="lblRadio">
                                                                           <input type="radio" name="radio" />
                                                                           <div className="checkmarkRdio">
                                                                                <img src="src/login-bg.jpg" className="w-100 mb-2" alt="" />
                                                                                <span>C</span>
                                                                                Dummy Text
                                                                           </div>
                                                                      </label>
                                                                      <label className="lblRadio">
                                                                           <input type="radio" defaultChecked="checked" name="radio" />
                                                                           <div className="checkmarkRdio">
                                                                                <img src="src/login-bg.jpg" className="w-100 mb-2" alt="" />
                                                                                <span>D</span>
                                                                                Dummy Text
                                                                           </div>
                                                                      </label>
                                                                 </div>
                                                                 <div className="w-100 text-right">
                                                                      <button type="button" onClick={() => setShowQuestion("end")} className="mainBtn tabe bg-white mt-4 btnQas">Next</button>
                                                                 </div>
                                                            </div> */}
                                                       {/* </form> */}
                                                  </div>
                                             </div>
                                        </div>
                                   }
                                   {
                                        quesno === 'end' &&
                                        <div className="row m-0">
                                             <div className="col-md-12 p-0">
                                                  <div className="w-100 qusSec px-4 py-5 h-100 text-center congSrc">
                                                       <h3 style={{ color: "#ee6917" }}>Yipee !! You Earned 100 points </h3>
                                                       <lottie-player src="../images/112766.json" background="transparent" speed={1} className=" text-center mx-auto d-block" style={{ height: '150px' }} autoPlay>
                                                       </lottie-player>
                                                       <h4>Congratulations!!</h4>
                                                       <p style={{ fontWeight: 600 }} className="mb-5">You have successfully submit survey</p>
                                                       <a className="mainbtn fadeInUp" data-bs-dismiss="modal" onClick={(e) => { setQuesNumber(0) }}  >Close</a>
                                                  </div>
                                             </div>
                                        </div>
                                   }
                              </div>
                         </div>
                    </div>
               </div>
               <Footer />
          </>
     )
}
export default Home
